
import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

const BrowseErrorState: React.FC = () => {
  const { resolvedTheme } = useTheme();
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';
  const mutedTextColor = resolvedTheme === 'dark' ? 'text-white/70' : 'text-black/70';
  const bgColor = resolvedTheme === 'dark' ? 'bg-netflix-black' : 'bg-background';
  
  return (
    <div className={cn("min-h-screen", bgColor)}>
      <div className="article-container py-8">
        <h1 className={cn("text-3xl font-chroma mb-8", textColor)}>Browse</h1>
        <div className="p-6 border rounded-md">
          <p className={cn("text-lg", mutedTextColor)}>
            There was an error loading the stories. Please try again later.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BrowseErrorState;
